import type { TextProps } from '@chakra-ui/react'
import { Text } from '@chakra-ui/react'
import type { FC } from 'react'

import impactColor from '@app/pages/strategies/components/nodes/simulator/impactColor'
import type { DomainNode } from '@app/types'
import { formatTotal } from '@app/utils/metricHelpers'

type ImpactProps = TextProps & {
  rootNode: Pick<DomainNode, 'data'>
  value: number
}

const Impact: FC<ImpactProps> = ({ rootNode, value, ...rest }) => {
  const rootMetric = rootNode?.data
  const name = rootMetric?.name || 'Unnamed'
  const sign = value >= 0 ? '+' : ''
  const color = impactColor(value)

  return (
    <Text fontSize="lg" color={`${color}.700`} bgColor={`${color}.subtle`} {...rest}>
      {sign}
      {formatTotal(value, rootMetric?.displayFormat || 'number', rootMetric)} {name} impact
    </Text>
  )
}

export default Impact
